import { queryNewsPageApi } from '@eastcoal/api/content/newsMall/queryNewsPage'

import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { ListTitleLink } from '../../../../components/ListTitleLink'
import { NEWS_DETAIL_PAGE_PATH } from '../../../Content/News/constants/path'

import { NewsListProps, NewsListTableProps } from './interface'

const columns: NewsListTableProps['columns'] = [
  {
    dataIndex: 'title',
    render(_, { id, title }) {
      return (
        <ListTitleLink
          to={stringifyUrl({
            url: NEWS_DETAIL_PAGE_PATH,
            query: { id }
          })}
        >
          {title}
        </ListTitleLink>
      )
    }
  },
  {
    dataIndex: 'publishTime',
    width: 140,
    align: 'right',
    valueType: {
      type: 'text',
      secondary: true
    }
  }
]

export const NewsList = ({ catalogueCode }: NewsListProps) => {
  return (
    <RemoteTable
      api={queryNewsPageApi}
      bordered={false}
      columns={columns}
      defaultPageSize={10}
      pagination={false}
      rowKey='id'
      showHeader={false}
      requestParams={{
        catalogueCode,
        orders: [
          {
            column: 'publish_time',
            asc: false
          }
        ]
      }}
    />
  )
}
